// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__lncp3","name":"Header_name__1kZKL","birthday":"Header_birthday__3UPQi","skeleton":"Header_skeleton__2gM6H"};